var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sb-drawer',{class:[_vm.$mq, _vm.isAdmin ? 'sb-drawer--admin' : ''],attrs:{"active":_vm.showDrawer},on:{"update:active":function($event){_vm.showDrawer=$event}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }